'use client';

import { alpha, Avatar, useTheme, AvatarProps } from '@mui/material';

type Props = AvatarProps & {
  name: string;
};

const StyledAvatar = ({ name, ...rest }: Props) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <Avatar
      variant={'rounded'}
      sx={{
        borderRadius: 0.4,
        color: alpha(theme.palette.common[isDark ? 'white' : 'black'], 0.6),
        bgcolor: alpha(theme.palette.common[isDark ? 'white' : 'black'], 0.1),
      }}
      {...rest}
    >
      {name
        ?.split(' ')
        .map((e: string) => e[0])
        .join('')
        .slice(0, 2)}
    </Avatar>
  );
};

export default StyledAvatar;
